// import { collection, getDocs, doc, getDoc, addDoc } from "firebase/firestore";
// import { getDownloadURL, ref } from "firebase/storage";
// import db from "@/firebase/config";

export default {
  namespaced: true,
  state() {
    return {
      properties: [],
      currentProperty: null,
      images: [],
      splitProperties: [],
      isLaoding: false,
    };
  },
  getters: {
    properties(state) {
      return state.properties;
    },
    currentProperty(state) {
      return state.currentProperty;
    },

    images(state) {
      return state.images;
    },
    splitProperties(state) {
      return state.splitProperties;
    },
  },
  mutations: {
     setProperties(state, payload) {
      console.log("in mutation setProperties");
      console.log(payload);
      state.properties = payload;
    },
    setCurrentProperty(state, payload) {
      console.log("in mutation setCurrentProperty");
      state.currentProperty = payload;
    },

    setCurrentPropertyImages(state, payload) {
      state.images = payload;
    },

    setTheSplitProperties(state, splitsize) {
      // Size of chunk
      let chunkSize = splitsize;
      console.log(splitsize);
      // Initialize the output array
      let chunks = [];

      // Loop to split array into chunks
      for (let i = 0; i < state.properties.length; i += chunkSize) {
        let chunk = [];

        // Iterate for the size of chunk
        for (let j = i; j < i + chunkSize && j < state.properties.length; j++) {
          chunk.push(state.properties[j]);
        }

        // push the chunk to output array
        chunks.push(chunk);
      }
      state.splitProperties = chunks;
    },
    setLoggedInUser(state, user) {
      console.log("Setting logged-in user:", user);
      state.loggedInUser = user; // Store the user in the Vuex state
    },
    setUsersList(state, users) {
      console.log("Setting users list:", users);
      state.usersList = users; // Store the user in the Vuex state
    },

    setServiceRequests(state, serviceRequests) {
      console.log("Setting service requests:", serviceRequests);
      state.serviceRequests = serviceRequests; // Store the user in the Vuex state
    },

    updatePropertyInState(state, { id, field, value }) {
      const propertyIndex = state.properties.findIndex(p => p.id === id);
      if (propertyIndex !== -1) {
        const updatedProperty = {
          ...state.properties[propertyIndex],
          [field]: value
        };
        state.properties.splice(propertyIndex, 1, updatedProperty);
        if (state.currentProperty && state.currentProperty.id === id) {
          state.currentProperty = updatedProperty;
        }
      }
    },
     setLoading(state, status) { // 2. Add a mutation to change the loading state
      state.isLoading = status;
    },
  },
  actions: {
    // This function should remain
    getLocalStorageItemWithExpiry(context, data) {
      const itemStr = localStorage.getItem(data.key);
      if (!itemStr) {
        return null;
      }
      const item = JSON.parse(itemStr);
      const now = new Date();
      if (now.getTime() > item.expiry) {
        localStorage.removeItem(data.key);
        return null;
      }
      return item.value;
    },

    // This function should remain
    async loadProperties(context) {
      const localProperties = context.dispatch("getLocalStorageItemWithExpiry", {
        key: "localProperties",
      });
      if (localProperties && localProperties.length > 0) {
        context.commit("setProperties", localProperties);
      } else {
        const response = await fetch(process.env.VUE_APP_getPropertiesURL);
        const properties = await response.json();
        context.commit("setProperties", properties);
      }
    },

    // This is the function that was modified
    async loadAdminProperties(context) {
       context.commit('setLoading', true); // Set loading to true at the start
      try {
        const user = context.rootState.auth.user;
        if (!user) throw new Error("User is not authenticated.");
        const token = await user.getIdToken();

        const response = await fetch(
          process.env.VUE_APP_getPropertiesURL,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
            method: "GET",
          }
        );

        if (!response.ok) throw new Error("Failed to fetch admin properties.");
        
        const properties = await response.json();

        const normalizedProperties = properties.map(prop => {
          return {
            ...prop,
            Verified: ['true', 'yes', 1, true].includes(String(prop.verified).toLowerCase()),
            PropertyClosed: ['true', 'yes', 1, true].includes(String(prop.propertyClosed).toLowerCase()),
            PropertyArchived: ['true', 'yes', 1, true].includes(String(prop.PropertyArchived || prop.propertyArchived).toLowerCase())
          };
        });

        context.commit("setProperties", normalizedProperties);
      } catch (error) {
        console.error("Error loading admin properties:", error);
      }finally {
        context.commit('setLoading', false); // Set loading to false at the end
      }
    },

    // This function should remain
    async updatePropertyStatus(context, { id, field, value }) {
      try {
        const user = context.rootState.auth.user;
        if (!user) throw new Error("User is not authenticated. Cannot update property.");
        const token = await user.getIdToken();

        const response = await fetch(
          process.env.VUE_APP_updatePropertyStatusURL,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              "Authorization": `Bearer ${token}`,
            },
            body: JSON.stringify({ id, field, value }),
          }
        );

        if (!response.ok) {
          const errorText = await response.text();
          throw new Error(`Failed to update property status: ${errorText}`);
        }

        context.commit('updatePropertyInState', { id, field, value });
        localStorage.removeItem('localProperties');
        localStorage.removeItem(id);
      } catch (error) {
        console.error("Error in updatePropertyStatus action:", error);
        throw error;
      }
    },
   

    setLocalStorageItemWithExpiry(context, data) {
      const { key, value, expiryInSeconds } = data;

      console.log(expiryInSeconds);
      console.log(Number(expiryInSeconds));
      const now = new Date();
      const expiryTime = now.getTime() + Number(expiryInSeconds) * 1000; // Calculate expiry time in milliseconds

      const item = {
        value: value,
        expiry: expiryTime,
      };

      localStorage.setItem(key, JSON.stringify(item)); // Store item with expiry

      // Check for expiry when retrieving the item (see below)
    },

  async setCurrentProperty(context, data) {
      console.log("in action setCurrentProperty");
      const localProperty = await context.dispatch(
        "getLocalStorageItemWithExpiry",
        { key: data }
      );

      if (localProperty) {
        const curProperty = localProperty;
        context.commit("setCurrentProperty", curProperty);
      } else {
        try {
          if (context.getters.properties.length == 0) {
            console.log("properties not in store");
            console.log(
              "calling loadPropertiesfirebaseAdmin from setCurrentProperty"
            );
            await context.dispatch("loadPropertiesfirebaseAdmin");
          }
        } catch (error) {
          console.log("unable to fetch properties", error);
          throw error;
        }
        let curProperty = context.getters.properties.find(
          (req) => req.id === data
        );
        console.log(context.getters.properties);
        console.log(data);
        console.log("Returning property:");
        console.log(curProperty);
        const images = curProperty.image;
        const requestBody = {
          imageUrls: images,
        };
        console.log(images);

        // for (let i = 0; i < curProperty.imagesUrls.length; i++) {
        try {
          const response = await fetch(
            process.env.VUE_APP_getDownloadURLS,
            // "http://127.0.0.1:3000/vue-http-demo-30473/us-central1/getDownloadURLS",
            {
              headers: {
                "Content-Type": "application/json",
              },
              body: JSON.stringify(requestBody),
              method: "POST",
            }
          );

          //  const imgUrl= await getDownloadURL( ref(storage, curProperty.imagesUrls[i]));
          //     curProperty.imagesUrls[i] = imgUrl;
          //     imageMap.set(i,imgUrl);
          const imgProcessed = await response.json();
          curProperty = { ...curProperty, ImageMap: imgProcessed };
          console.log("currentProperty :: ", curProperty);
        } catch (error) {
          console.log("unable to download url ", error);
          throw error;
        }
        // };

        //   curProperty={...curProperty,ImageMap: imageMap};
        // console.log("89898989")
        // console.log(curProperty);

        if (curProperty) {
          context.dispatch("setLocalStorageItemWithExpiry", {
            key: data,
            value: curProperty,
            expiryInSeconds: 120,
          });
        }
        context.commit("setCurrentProperty", curProperty);
      }
    },

    async setTheSplitProperties(context, splitsize) {
      console.log("@@");
      console.log(splitsize);
      context.commit("setTheSplitProperties", splitsize);
    },

    async loadPropertiesfirebaseAdmin(context) {
      const localProperties = await context.dispatch(
        "getLocalStorageItemWithExpiry",
        { key: "localProperties" }
      );
      if (localProperties) {
        console.log("properties from local");
        const properties = localProperties;
        context.commit("setProperties", properties);
      } else {
        console.log("making srv call for properties");
        const response = await fetch(
          process.env.VUE_APP_getPropertiesURL,
          // "http://127.0.0.1:3000/vue-http-demo-30473/us-central1/getTheProperties",
          {
            headers: {
              "Content-Type": "application/json",
            },
            method: "GET",
          }
        );
        // const data = await response.text();
        var properties = await response.json();
        console.log(`property size before filter  ${properties.length}`);
        console.log("Filetered properties");
        console.log(properties);
        properties = properties.filter(
          (property) => property.verified === true &&property.propertyArchived !== true
        );
        console.log(`properties length after filter ${properties.length}`);``
        if (properties) {
          context.dispatch("setLocalStorageItemWithExpiry", {
            key: "localProperties",
            value: properties,
            expiryInSeconds: 120,
          });
        }
        context.commit("setProperties", properties);
      }
    },
  },
};
